module.exports = __webpack_public_path__ + "img/PC-bg.01489c39.png";